import { InstagramOutlined, MailOutlined } from "@ant-design/icons";
import "./App.css";
import avatarImg from "./assets/avatar.png";

function App() {
  return (
    <div className="profile-page">
      <div className="profile-card">
        <div className="profile-avatar">
          <img src={avatarImg} alt="Profile" />
        </div>
        <h1 className="profile-name">Ana Zatic</h1>
        <p className="profile-title">Social Media Manager, Graphic Designer & Video Editor</p>
        <div className="profile-contact-icons">
          <a
            href="mailto:contact@anacreate.com"
            title="Email"
            className="icon-btn"
          >
            <MailOutlined style={{ fontSize: "20px" }} />
          </a>
          <a
            href="https://www.instagram.com/ana_design_space/"
            title="Instagram"
            className="icon-btn"
            target="_blank"
            rel="noopener noreferrer"
          >
            <InstagramOutlined style={{ fontSize: "20px" }} />
          </a>
        </div>
        <div className="profile-actions">
          <a
            className="profile-action-btn"
            href="https://www.upwork.com/freelancers/~01c7d609b85f6920cb"
            target="_blank"
            rel="noopener noreferrer"
          >
            Upwork
          </a>
          <a
            className="profile-action-btn"
            href="https://www.behance.net/gallery/216668063/Ana-Zatic-Portfolio-2025"
            target="_blank"
            rel="noopener noreferrer"
          >
            My Graphic Design Portfolio
          </a>
          <a
            className="profile-action-btn"
            href="https://ana-zatic-portfolio.my.canva.site/"
            target="_blank"
            rel="noopener noreferrer"
          >
            My Video Editing Portfolio
          </a>
        </div>
      </div>

      <div className="about-section">
        <div className="about-content">
          <div className="about-text">
            <h2>About me</h2>
            <p>
              Since 2020, I've been working in creative roles - starting with
              Illustration and Graphic Design, and also writing blog content to
              support and enhance the projects I was working on.
            </p>
            <p>
              Over time, I moved into Video Editing and Social Media Management.
              What amazed me early on was how powerful visuals can be,
              especially when paired with the right words and the right
              platform.
            </p>
            <p>
              I come from a tech background with a Bachelor's degree in IT,
              which has helped me bring a more structured, strategic approach to
              my creative work. I've always been drawn to making things that are
              simple but meaningful, and I try to carry that mindset into every
              project. Whether it's editing a video, writing content, or
              planning a strategy, I enjoy the process of turning ideas into
              something that delivers value and gets results.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
